import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Provider.DeleteLogo.IRequest;
type Response = Api.Core.Provider.DeleteLogo.IResponse;
type Headers = Api.Core.Provider.DeleteLogo.IHeaders;
const apiPath = '/api/ProductManagement/Provider/:id/Logo/:logoId';
export default async function providerDeleteLogoApi(id: number, request: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    body: request,
    url: createPathFromRoute(apiPath, { id, logoId: request.logoId }),
    method: HttpMethod.delete,
    headers: getDefaultHeaders(),
  });
}
